export default __webpack_public_path__ + "static/media/Godspeed.62576316.png";